import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubspotCertificationIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getIsNewOffering } from 'marketplace-ui-common/offerings/utils';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * [Storybook](https://private.hubteamqa.com/trellis-ecosystem-storybook/?path=/docs/trellis-ecosystem-ecosystemappcard)
 * */
export function EcosystemAppCard({
  appName,
  certified,
  customBody,
  customFooter,
  firstPublishedAt,
  iconUrl,
  installCount,
  installed,
  layout,
  marginBlockEnd,
  onClick,
  providerName,
  ribbon,
  tagline
}) {
  return /*#__PURE__*/_jsxs(CardWrapper, {
    padding: "600",
    marginBlockEnd: marginBlockEnd,
    children: [ribbon && /*#__PURE__*/_jsx(Ribbon, {
      use: ribbon.use,
      children: ribbon.text
    }), /*#__PURE__*/_jsx(Clickable, {
      "data-test-id": "ecosystem-app-card",
      onClick: onClick
      // if there's no onClick, we should not keyboard focusable, since most
      // likely we are already wrapped in a focusable element, and this would
      // create duplicate keyboard navigation
      ,
      tabIndex: onClick ? 0 : -1,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        blockSize: "100%",
        gap: "400",
        flexDirection: layout === 'grid' ? 'column' : 'row',
        paddingBlockStart: ribbon ? '250' : undefined,
        children: [/*#__PURE__*/_jsx(Image, {
          src: iconUrl,
          inlineSize: "40px",
          alt: appName
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "400",
          blockSize: "100%",
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsxs(Text, {
              as: "h4",
              children: [appName, "\xA0", certified && /*#__PURE__*/_jsx(CertifiedBadge, {})]
            }), /*#__PURE__*/_jsxs(Flex, {
              gap: "200",
              children: [providerName && /*#__PURE__*/_jsx(ProviderName, {
                providerName: providerName
              }), !installed && /*#__PURE__*/_jsx(InstallCount, {
                firstPublishedAt: firstPublishedAt,
                installCount: installCount
              })]
            })]
          }), tagline && /*#__PURE__*/_jsx(Text, {
            typography: "body-200",
            color: "text-core-subtle",
            children: tagline
          }), customBody, installed && /*#__PURE__*/_jsx(InstalledTag, {}), customFooter]
        })]
      })
    })]
  });
}
function CertifiedBadge() {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trellisEcosystem.appCard.certified"
    }),
    children: /*#__PURE__*/_jsx(IconHolder, {
      color: "fill-brand-default",
      "data-test-id": "certified-badge",
      icon: HubspotCertificationIcon,
      padding: "0",
      size: "500",
      verticalAlign: "-2px"
    })
  });
}
function ProviderName({
  providerName
}) {
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trellisEcosystem.appCard.providerName",
      options: {
        providerName
      }
    })
  });
}
function InstallCount({
  firstPublishedAt,
  installCount
}) {
  if (firstPublishedAt && getIsNewOffering(firstPublishedAt)) {
    return /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'trellisEcosystem.appCard.new'
      })
    });
  }
  if (installCount === undefined) return null;
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    color: "text-core-subtle",
    children: formatInstalls(installCount)
  });
}
function InstalledTag() {
  return /*#__PURE__*/_jsx(StatusTag, {
    use: "success",
    marginBlockStart: "auto",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trellisEcosystem.appCard.installed"
    })
  });
}